import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, canonical, ogImage, noindex, schema, children }) => {
  const siteName = "FastInvoice";
  const defaultTitle = "FastInvoice | India's Smartest Invoicing & Billing Platform";
  const defaultDescription = "FastInvoice.in is the simplest, most powerful invoicing & billing platform built for Indian freelancers, SMEs, and enterprises. Create GST-ready invoices in 60 seconds.";
  
  const seoTitle = title ? `${title} | ${siteName}` : defaultTitle;
  const seoDescription = description || defaultDescription;
  const seoCanonical = canonical || "https://fastinvoice.in";
  
  // Use a default OG image if one isn't provided (e.g. an absolute URL to a social card image)
  const seoImage = ogImage || "https://fastinvoice.in/social-card.jpg";

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {!noindex && <meta name="robots" content="index, follow" />}
      <link rel="canonical" href={seoCanonical} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={seoCanonical} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={seoImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={seoCanonical} />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:image" content={seoImage} />

      {/* JSON-LD Schema */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}

      {children}
    </Helmet>
  );
};

export default SEO;
